import { useHierarchyArea } from '@plarium/hierarchy-react';
import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ExpandMoreIcon,
  Grid,
  LegacyText,
} from '@gogame/components';
import { FormField, withFormFieldGroupFormField } from '@gogame/form';

import { loadGGLinks } from 'scenes/Influencers/InfluencersCampaigns/sources/fields';

import { LinkText } from './components';
import { ADDITIONAL_PARAMS } from './constants';
import { getGGCampaignLinkDependencies } from './dependencies';
import { ggCampaignLinkSchema } from './schemas';

const GGCampaignLink = withFormFieldGroupFormField({
  schema: ggCampaignLinkSchema,
})(
  ({
    name,
    platformName,
    isEdit,
    trackingLink: initialTrackingLink,
    ggLink: initialGgLink,
  }) => {
    const depends = React.useMemo(
      () => getGGCampaignLinkDependencies(name),
      [name]
    );

    const { data } = useHierarchyArea({
      name,
      source: loadGGLinks,
      depends,
      active: !isEdit,
    });

    const trackingLink = data?.trackingLink || initialTrackingLink;
    const ggLink = data?.ggLink || initialGgLink;

    return (
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon color={'action'} />}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <LegacyText size={'14px'}>{platformName}</LegacyText>
            </Grid>
            <Grid item xs={8}>
              <LinkText size={'12px'}>{ggLink}</LinkText>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item container spacing={2} direction={'column'} xs={12}>
              <Grid item>
                <LegacyText size={'14px'}>
                  Target URL (Tracking Link)
                </LegacyText>
              </Grid>
              {trackingLink ? (
                <Grid item>
                  <LinkText size={'14px'} wordBreak={'break-all'}>
                    {trackingLink}
                  </LinkText>
                </Grid>
              ) : null}
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={12}>
                <FormField.TextField
                  name={ADDITIONAL_PARAMS}
                  label={'Additional Params'}
                  placeholder={'&parameter=value'}
                  debounceTimeout={300}
                  padding={0}
                  disabled={isEdit}
                />
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
);

export default GGCampaignLink;
